export const tyreQueryKeys = {
  all: ['tyre-management-v2'],
  overview: () => ['tyre-management-v2', 'overview'],
  configuration: () => ['tyre-management-v2', 'configuration'],
  vehicles: (params = {}) => ['tyre-management-v2', 'vehicles', params],
  vehicleLayouts: () => ['tyre-management-v2', 'vehicle-layout'],
  vehicleLayout: (vehicleId) => ['tyre-management-v2', 'vehicle-layout', String(vehicleId || '')],
  layouts: (params = {}) => ['tyre-management-v2', 'layouts', params],
  tyres: (params = {}) => ['tyre-management-v2', 'tyres', params],
  tyre: (id) => ['tyre-management-v2', 'tyre', String(id || '')],
  tyreHistory: (id) => ['tyre-management-v2', 'tyre-history', String(id || '')],
  tyreLookup: (token) => ['tyre-management-v2', 'tyre-lookup', String(token || '')],
  retreading: (params = {}) => ['tyre-management-v2', 'retreading', params],
  report: (params = {}) => ['tyre-management-v2', 'report', params],
  reportJobs: () => ['tyre-management-v2', 'report-jobs'],
  reportJob: (id) => ['tyre-management-v2', 'report-job', String(id || '')],
  reportJobResult: (id) => ['tyre-management-v2', 'report-job-result', String(id || '')],
  reportJobStatuses: (ids) => ['tyre-management-v2', 'report-job-statuses', ids],
  sites: () => ['tyre-management-v2', 'sites'],
};

export const invalidateTyreData = (queryClient) => Promise.all([
  queryClient.invalidateQueries({ queryKey: tyreQueryKeys.all }),
]);
